import React, { useState, useEffect } from 'react';
import Maze from './Maze.js'
const ProgressSSE = ({ userId }) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const styleSheet = document.createElement("style");
        styleSheet.type = "text/css";
        styleSheet.innerHTML = `
            @keyframes spinner {
                from { transform: rotate(0deg); }
                to { transform: rotate(360deg); }
            }
            @keyframes blinking {
                0% { opacity: 1; }
                100% { opacity: 0; }
            }
        `;
        document.head.appendChild(styleSheet);
        return () => document.head.removeChild(styleSheet);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return prev;
                }
                return prev + 0.5;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const spinnerStyle = {
        position: 'absolute',
        width: 'calc(100% - 9.9px)',
        height: 'calc(100% - 9.9px)',
        border: '5px solid transparent',
        borderTopColor: '#0288D1',
        borderRadius: '50%',
        animation: 'spinner 5s cubic-bezier(0.17, 0.49, 0.76, 0.96) infinite'
    };

    return (
        <div
            className="spinner-body"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {/* 中央配置の中身全体 */}
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {/* スピナー */}
                <div
                    className="spinner-container"
                    style={{
                        width: '150px',
                        height: '150px',
                        position: 'relative',
                        overflow: 'hidden',
                    }}
                >
                    <div className="spinner" style={spinnerStyle}>
                        <div className="spinner" style={spinnerStyle}>
                            <div className="spinner" style={spinnerStyle}>
                                <div className="spinner" style={spinnerStyle}></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* プログレスバー */}
                <div
                    style={{
                        width: "300px",
                        height: "30px",
                        border: "1px solid black",
                        borderRadius: "5px",
                        overflow: "hidden",
                        background: "#f3f3f3",
                        marginTop: "20px"
                    }}
                >
                    <div
                        style={{
                            width: `${progress}%`,
                            height: "100%",
                            background: "#f009fd",
                            transition: "width 0.3s ease-in-out"
                        }}
                    />
                </div>

                {/* 数値表示 */}
                <p
                    style={{
                        color: '#1feb85',
                        fontFamily: 'fantasy',
                        fontSize: '25px',
                        margin: '10px 0 0 0'
                    }}
                >
                    {progress ? Math.floor(progress) : "0"}%
                </p>

                {/* ローディングテキスト */}
                <div
                    className="loading-text"
                    style={{
                        textAlign: 'center',
                        color: 'white',
                        fontSize: '20px',
                        animation: 'blinking 1s infinite alternate',
                        marginTop: '10px'
                    }}
                >
                    Now Generating...
                </div>
                {<Maze />}
            </div>
        </div>
    );
};

export default ProgressSSE;
